export default __webpack_public_path__ + "static/media/generate-card.19fbb4a2.svg";